export const APP_DETAILS = {
  FA_NAME: 'آپارات کودک',
  EN_NAME: 'Aparat Kids',
  AR_NAME: 'آپارات کودک',
  TJ_NAME: 'Aparat Kids',
  FA_DESCRIPTION: 'آپارات کودک تی وی',
  EN_DESCRIPTION: 'Aparat Kids TV',
  AR_DESCRIPTION: 'آپارات کودک تی وی',
  TJ_DESCRIPTION: 'Aparat Kids телевизион',
};

export const APP_API = {
  PROXY_URL: 'https://www.aparatkids.com',
  API_PROTOCOL: 'https',
  API_SUBDOMAIN: 'www',
  API_BASE: 'aparatkids.com',
  API_PATH: 'api',
  API_VERSION: 'v1',
};

export const APP_GLOBAL_CONFIG = {
  APP_VERSION: '1.1.0',
  ROWS_PER_PAGE: 5,
  GOOGLE_TAG_MANAGER: 'GTM-M99TGCJ',
  LOGIN_URL: 'https://aparatkids.com/activate',
  APPS_URL: 'https://aparatkids.com/app',
};
